module.exports = __webpack_public_path__ + "img/form-toggle.2759dd84.svg";